import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import noData from "../../../assets/images/nodata.png";
import "../noDataFound/noDataFound.scss";

/** Empty state when Echo is turned off for the selected college. */
const EchoNotConfigured = () => {
  const theme = useTheme();
  return (
    <Typography className="noData-search-blk" component="div">
      <Typography component="div">
        <img src={noData} alt="" className="no-data-img" />
        <Typography
          sx={{ color: theme.palette.customColor.textDark }}
          component="div"
          className="no-data-msg"
        >
          Echo is not configured for this college
        </Typography>
      </Typography>
    </Typography>
  );
};

export default EchoNotConfigured;
